import {
  CHECK_ATTEMPT_REASON_LABELS,
  type CheckAttemptItem,
  type CheckAttemptOutcome
} from '@/Network/Types/Responses/CheckAttemptsResponses'

export const ACCEPTED_COLOR = '#16a34a'
export const REJECTED_COLOR = '#dc2626'

export function outcomeColor(outcome: CheckAttemptOutcome): string {
  return outcome === 'ACCEPTED' ? ACCEPTED_COLOR : REJECTED_COLOR
}

export function reasonLabel(item: Pick<CheckAttemptItem, 'outcome' | 'reason'>): string {
  if (item.outcome === 'ACCEPTED') return 'Aceita'
  return item.reason ? CHECK_ATTEMPT_REASON_LABELS[item.reason] : 'Rejeitada'
}

export function formatDistance(meters: number | null | undefined): string {
  if (meters == null || !Number.isFinite(meters)) return '—'
  if (meters >= 1000) return `${(meters / 1000).toFixed(1).replace('.', ',')} km`
  return `${Math.round(meters)} m`
}

export function formatCoords(lat: number | null, lng: number | null): string {
  if (lat == null || lng == null) return '—'
  return `${lat.toFixed(5)}, ${lng.toFixed(5)}`
}

export function mapsLink(lat: number, lng: number): string {
  return `https://www.google.com/maps?q=${lat},${lng}&z=17&hl=pt-BR`
}
